import Container from '~/components/common/container';
import Button from '~/components/common/button';
import { JarirRedBrand } from '~/svgs/jarir';
import Image from 'next/image';
import { Translate, useTranslate } from '~/i18n';
import { isJarir } from '~/utils/theme';

const TopSection = ({ contactUsFormRef }: any) => {
   const { dir } = useTranslate();

   return (
      <div>
         <Container className="grid mt-16 mb-10 text-center lg:hidden py-7 tablet:mt-0 justify-items-center">
            <div
               className="flex flex-col font-semibold text-center"
               style={
                  dir === 'rtl' ? { flexDirection: 'column-reverse' } : { flexDirection: 'column' }
               }>
               <div className="text-5xl" style={{ lineHeight: '60px' }}>
                  <Translate id="ticketing:headline" />
               </div>
               <div className="text-[#0552bc] text-5xl pt-2 py-3">
                  <Translate id="ticketing:one platform" />
               </div>
            </div>
            <div className="grid xs:w-1/2 justify-items-center rtl:pt-1">
               <img src="/images/ticketing/ticketing-bg.png" />
               <div className="text-[#6C757D] text-sm pt-[20px] leading-[25px]">
                  <Translate id="ticketing:sub headline" />
               </div>
               <div className="w-[240px] mt-[21px] mb-[10px]">
                  <Button
                     onClick={() =>
                        contactUsFormRef?.current?.scrollIntoView({
                           block: 'center',
                           inline: 'center',
                           behavior: 'smooth',
                        })
                     }
                     className="!bg-[#0552bc]  !h-[44px] !py-[0px] border-0 w-full  requestcallback-top">
                     <Translate id="business:request a call back" />
                  </Button>
               </div>
            </div>
            {!isJarir ? (
               <>
                  <div className="uppercase text-[10px] text-[#495057] tracking-widest mt-[26px] leading-[13px]">
                     <Translate id="business:built in partnership with" />
                  </div>
                  <div className="pt-2">
                     <JarirRedBrand />
                  </div>
               </>
            ) : null}
         </Container>
         <div className="hidden pb-20 lg:block">
            <Container>
               <div className="flex-col justify-between w-full mt-12 bg-no-repeat bg-contain lg:flex lg:flex-row">
                  <Container>
                     <div className="flex justify-between">
                        <div className="w-5/12 px-2 pt-12">
                           <div
                              className="flex flex-col tracking-[-3.8px] leading-[93px] font-semibold "
                              style={
                                 dir === 'rtl'
                                    ? { flexDirection: 'column' }
                                    : { flexDirection: 'column-reverse' }
                              }>
                              <div className="text-6xl" style={{ lineHeight: '70px' }}>
                                 <Translate id="ticketing:headline" />
                              </div>
                              <div className="order-first text-[#0552bc] text-6xl pb-3">
                                 <Translate id="ticketing:one platform" />
                              </div>
                           </div>
                           <div className="text-[#6C757D] text-[20px] leading-[33px] tracking-[-0.77px]">
                              <Translate id="ticketing:sub headline" />
                           </div>
                           {!isJarir ? (
                              <div className="flex pt-[20px]">
                                 <div
                                    className="uppercase text-[10px] text-[#343A40] pt-[12px] leading-[13px]"
                                    style={
                                       dir === 'rtl'
                                          ? { letterSpacing: '0px', paddingRight: '1px' }
                                          : { letterSpacing: '2.5px', paddingLeft: '1px' }
                                    }>
                                    <Translate id="business:built in partnership with" />
                                 </div>
                                 <div className="px-3 pt-2">
                                    <JarirRedBrand />
                                 </div>
                              </div>
                           ) : null}
                           <div>
                              <div className="w-[240px] mt-[44px]">
                                 <Button
                                    onClick={() =>
                                       contactUsFormRef?.current?.scrollIntoView({
                                          block: 'center',
                                          inline: 'center',
                                          behavior: 'smooth',
                                       })
                                    }
                                    className="!bg-[#0552bc] !h-[53px] border-0 w-full requestcallback-top">
                                    <Translate id="business:request a call back" />
                                 </Button>
                              </div>
                           </div>
                        </div>
                        <div className="px-4">
                           <Image
                              src="/images/ticketing/ticketing-bg.png"
                              width={520}
                              height={575}
                           />
                        </div>
                     </div>
                  </Container>
               </div>
            </Container>
         </div>
      </div>
   );
};
export default TopSection;
